import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ShipyardSocketService } from '@service/shipyard-socket.service';
import { ShipyardService } from '@service/shipyard.service';
import { VesselSocketService } from '@service/vessel-socket.service';
import { VesselService } from '@service/vessel.service';
import { Vessel } from 'icreate/common/models/vessel';
import { filter, Subject, takeUntil } from 'rxjs';

export enum HomePages {
    UNDEFINED = 'undefined',
    HOME = 'home',
    SETTINGS = 'settings',
    DEVICE_MANAGMENT = 'device-managment',
    DEVIE_LIST = 'device-list',
    SPECIFICATION = 'specification',
}

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false,
})
export class HomeComponent implements OnInit, OnDestroy {
    private destroySubscriptions$: Subject<void> = new Subject();
    private selectedShipyard: string;
    private selectedVessel: Vessel;
    private selectedHomePage: HomePages;

    constructor(
        private shipyardSocketService: ShipyardSocketService,
        private shipyardService: ShipyardService,
        private vesselSocketService: VesselSocketService,
        private vesselService: VesselService,
        private router: Router
    ) {
        shipyardSocketService.startSubscriptions();
        vesselSocketService.startSubscriptions();
    }

    ngOnInit(): void {
        this.shipyardService.selectedShipyard$.pipe(takeUntil(this.destroySubscriptions$)).subscribe(shipyard => {
            this.selectedShipyard = shipyard;
        });

        this.vesselService.activeVessel$.pipe(takeUntil(this.destroySubscriptions$)).subscribe(vessel => {
            this.selectedVessel = vessel;
        });

        this.router.events
            .pipe(filter(event => (event as any)?.routerEvent instanceof NavigationEnd))
            .subscribe(event => {
                const urlSegments = ((event as any)?.routerEvent?.url as string).split('/');
                const homePages = Object.values(HomePages);

                if (urlSegments[1] == HomePages.HOME) {
                    this.selectedHomePage = null;
                    for (let i = 2; i < urlSegments.length; i++) {
                        const segment: any = urlSegments[i];
                        if (homePages.includes(segment)) {
                            this.selectedHomePage = segment;
                            break;
                        }
                    }
                } else {
                    this.selectedHomePage = null;
                }
            });
    }

    ngOnDestroy(): void {
        this.destroySubscriptions$.next();
        this.destroySubscriptions$.complete();
        this.vesselSocketService.destroySubscriptions();
        this.shipyardSocketService.destroySubscriptions();
    }

    async goToShipyard() {
        if (!this.selectedVesselData) return;
        await this.router.navigateByUrl(`/home/${this.selectedVessel.shipyardId}`);
    }

    async goToVessel() {
        if (!this.selectedPage) return;
        await this.router.navigateByUrl(`/home/${this.selectedVessel.shipyardId}/${this.selectedVessel.id}`);
    }

    get selectedShipyardName() {
        return this.selectedShipyard;
    }

    get selectedVesselData() {
        if (!this.selectedShipyardName) return;
        return this.selectedVessel;
    }

    get selectedPage() {
        if (!this.selectedShipyardName || !this.selectedVessel || !this.selectedHomePage) return;
        if (this.selectedHomePage == HomePages.SPECIFICATION || this.selectedHomePage == HomePages.DEVIE_LIST) {
            return 'vessel.page.button.system-spec';
        }
        return '';
    }

    get isDeviceListPage() {
        return this.selectedPage && this.selectedHomePage == HomePages.DEVIE_LIST;
    }

    get pageIcon() {
        if (!this.selectedShipyardName || !this.selectedVessel || !this.selectedHomePage) return;
        if (this.selectedHomePage == HomePages.SPECIFICATION || this.selectedHomePage == HomePages.DEVIE_LIST) {
            return 'device-list';
        }
        return '';
    }
}
